import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFacebookBrandedStyle0 = cosmosIconCss;

const CosmosIconFacebookBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFacebookBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '237c4861abd4d2d5fd46d68e935f6543e83ff931', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fa1fe34611e1718bcf3e0bdb164cc5161f13f8cb', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2712ddc75d69e776ee58c64499a195b35eedbe67', d: "M20.004 11.003a9 9 0 1 1-18.002 0 9 9 0 0 1 18.002 0Z", fill: "#fff" }), h("path", { key: '6dfae96b1e503d35ed0f83ed8f8ccabaeed55be6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 11a9 9 0 1 0-10.406 8.89v-6.288H7.309V11h2.285V9.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V11h2.496l-.399 2.602h-2.097v6.289A9.002 9.002 0 0 0 20 11Z", fill: "#0866FF" }))));
    }
    static get style() { return CosmosIconFacebookBrandedStyle0; }
}, [1, "cosmos-icon-facebook-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-facebook-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-facebook-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFacebookBranded$1);
            }
            break;
    } });
}

const CosmosIconFacebookBranded = CosmosIconFacebookBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFacebookBranded, defineCustomElement };
